var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lazyload)?_c('img',{staticClass:"v-mid lazyload",style:(`width: ${_vm.setLogoWidth}`),attrs:{"data-src":_vm.imageSrc,"alt":"Logo"}}):_c('img',{staticClass:"v-mid",style:(`width: ${_vm.setLogoWidth}`),attrs:{"src":_vm.imageSrc,"alt":"Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }